import apiRequest from './api-request';
import { MetadataSettableType } from '../types';

const emptyMetadata: MetadataSettableType = {
    vehicleTypes: [],
    equipment: [],
    sustainability: [],
    licencesCertificates: []
};

// The "Fair Transport" sustainability option is only settable for orders, not for tenants.
const filterMetadataForTenant = (metadata: MetadataSettableType): MetadataSettableType => {
    return {
        ...metadata,
        sustainability: metadata.sustainability.filter((sust: string) => sust !== 'Fair Transport')
    };
};

export const getSettableForOrder = async (): Promise<MetadataSettableType> => {
    try {
        const response = await apiRequest({
            method: 'GET',
            resource: 'metadata',
        });
        return response;
    } catch (error) {
        console.error('Error fetching metadata for order:', error);
        return Promise.resolve(emptyMetadata);
    }
};

export const getSettableForTenant = async (): Promise<MetadataSettableType> => {
    try {
        const response = await apiRequest({
            method: 'GET',
            resource: 'metadata',
        });
        return filterMetadataForTenant(response);
    } catch (error) {
        console.error('Error fetching metadata for tenant:', error);
        return Promise.resolve(emptyMetadata);
    }
};
